export const MCP_PRODUCT_NAME = 'AI Connector';
export const MCP_PRODUCT_NAME_PLURAL = 'AI Connectors';

/** "Learn more" destination for every Agent modes (Default / Full actions) surface. */
export const AGENT_MODES_LEARN_MORE_URL =
  'https://help.benchling.com/hc/en-us/articles/48328875643533-Agent-Modes';
